
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_SET_autoPayAccount, DEV_SET_houseColorNumber } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_isLoading } from "../../reducers/uiReducer";

import moment from 'moment';
import { throttle } from 'lodash';

import ColorSettings from "./ColorSettings";

const SettingsPage: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const [selectedColor] = useState<number>(hardmoneyData.houseColorNumber);
    const hasColorChanged = hardmoneyData.houseColorNumber !== selectedColor;

    const fetchHouseData = useCallback(
        throttle(async (houseColorNumber: number) => {
            dispatch(SET_isLoading(true));
            try {
                const res: HardMoneyState = await socketRequest("SaveSettings", {
                    houseID: hardmoneyData.houseID,
                    houseOwner: hardmoneyData.houseOwner,
                    houseColorNumber: houseColorNumber,
                }, hardmoneyData);
            
                if (res) {
                    if (isEnvBrowser()) {
                        //console.log("SET NEW house color", res);
                        dispatch(DEV_SET_houseColorNumber(houseColorNumber));
                    } else {
                        dispatch(SET_HOUSEDATA(res));
                    };
                } else {
                throw new Error("Invalid color data received.");
                }
            } catch (err) {
                console.error("Error color house data:", err);
            } finally {
                dispatch(SET_isLoading(false));
            }
        }, 3000),
        [dispatch] 
    );
      

    const handleSaveChanges = (e: React.MouseEvent) => {
        e.preventDefault();

        if (hasColorChanged && hardmoneyData.houseColorNumber >= 0) {
            //console.log("update server with new color");
            fetchHouseData(hardmoneyData.houseColorNumber);
        };
    };
    
    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
               // backgroundColor: "yellow",
                gap: "5vh",
                padding: "3vh 0",
                color: "rgba(255, 255, 255, 0.9)",
            }}
        >
            <div
                style={{
                   // fontWeight: "bold",
                    fontSize: "6vh",
                    //backgroundColor: "orange",
                    fontFamily: 'Oswald',
                    fontWeight: "500",
                }}
            >
                Property Settings
            </div>
            
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    //backgroundColor: "gray",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    overflow: "hidden",
                    gap: "5vh",
                }}
            >
                <div
                    style={{
                        width: "50%",
                        height: "100%",
                        //background: "yellow",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        //overflow: "auto",
                        flexDirection: "column",
                        gap: "2vh",
                    }}
                >
                    <div
                        style={{
                            fontSize: "3vh",
                           // fontWeight: "bold",
                           fontFamily: 'Oswald',
                           fontWeight: "500",
                        }}
                    >
                        WALL COLOR
                    </div>
                    
                    <ColorSettings/>
                </div>
                <div
                    style={{
                        width: "50%",
                        height: "100%",
                        //background: "orange",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                        overflow: "hidden",
                        flexDirection: "column",
                        gap: "2vh",
                    }}
                >

                    <div
                        onClick={(e) => handleSaveChanges(e)}
                        style={{
                            border: hasColorChanged ? `0.2vh solid rgb(${uiData.schemeColor})` : "0.2vh solid rgba(90, 90, 90, 0.8)",
                            backgroundColor: hasColorChanged ? `rgba(${uiData.schemeColor}, 0.2)` : "rgba(60, 60, 60, 0.8)",
                            padding: "1vh",
                            fontSize: "1.25vh",
                            fontFamily: 'Noto Sans',
                            fontWeight: "600",
                            borderRadius: "0.75vh",
                            transition: "border 0.5s ease, background-color 0.5s ease",
                            cursor: hasColorChanged  ? "pointer" : "auto",
                        }}
                    >
                        Save Changes
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
